import { FlexibleButtonHyperlinkModel } from '@services/flexible_component/mod';
import { Routeable } from './_flexible_identifier_routeable.component';
import { Text } from '@visiba-cortex/react-ui-std';
import { FONT_VARIANT } from '../../constants';
import styled from 'styled-components';
import { Icon } from '@components/icon.component';
import { rem } from '@visiba/std';
import { theme } from '@services/theme.service/theme';

interface Props {
	component: FlexibleButtonHyperlinkModel;
}

const elements = {
	container: styled.div`
		margin: ${rem(8)} 0;
		display: flex;
		align-items: center;
		color: ${theme.hyperLinkDefault};
		transition: color 200ms ease;

		&:hover {
			color: ${theme.hyperLinkHover};
		}
	`,
	linkWrapper: styled.div`
		display: flex;
		align-items: center;
	`,
	icon: styled.span`
		margin-left: ${rem(10)};
	`,
};

export function FlexibleButtonHyperlink({ component }: Props): JSX.Element {
	return (
		<elements.container data-testid='FlexibleButtonHyperlink'>
			<Routeable
				data-testid='FlexibleButtonHyperlink'
				url={component.url}
				requiresAuthentication={component.requiresAuthentication}
				openWith={component.openUrlWith}
			>
				<elements.linkWrapper>
					<Text font={FONT_VARIANT.BODY}>{component.title}</Text>
					<elements.icon aria-hidden='true'>
						<Icon type='arrowRight' center />
					</elements.icon>
				</elements.linkWrapper>
			</Routeable>
		</elements.container>
	);
}
